import { render, staticRenderFns } from "./DetailReturn.vue?vue&type=template&id=02fc259c"
import script from "./DetailReturn.js?vue&type=script&lang=js&external"
export * from "./DetailReturn.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports